<template>
  <div style="clear:both;">
    <v-card>
      <v-toolbar dense density="compact">
        <v-toolbar-title>{{ $t('Owner_Decision') }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <template v-if="!showHistory">
          <v-data-table :headers="ownerDecisionHeaders" :items="od" class="elevation-1" disable-sort dense hide-default-footer density="compact">
            <template v-slot:item="props">
              <tr>
                <td class="userCell">{{ (ownerDecision.insertedBy || {}).displayName }}</td>
                <td v-if="props.item.decision === null" :class="getDecisionClass(props.item.decision)" class="decisionCell">
                  {{ $t('No_Response') }}
                </td>
                <td valign="top" v-else :class="getDecisionClass(props.item.decision)" class="decisionCell">
                  {{ props.item.decision.value }}
                </td>
                <td class="reasonCell" v-if="props.item.reason === null">{{ $t('No_Reason') }}</td>
                <td class="reasonCell" v-else>
                  <pre>{{ props.item.reason }}</pre>
                </td>
                <td class="dateCell" v-if="props.item.decisionDate != null">{{ $filters.DateTimeFilter(props.item.decisionDate) }}</td>
              </tr>
            </template>
          </v-data-table>
        </template>

        <!-- display only with history -->
        <template v-if="showHistory">
          <v-data-table :headers="ownerDecisionHeaders" :items="od" class="elevation-1" disable-sort dense hide-default-footer density="compact">
            <template v-slot:item="props">
              <tr>
                <td class="userCell">{{ (ownerDecision.insertedBy || {}).displayName }}</td>
                <td v-if="props.item.decision === null" :class="getDecisionClass(props.item.decision)" class="decisionCell">
                  {{ $t('No_Response') }}
                </td>
                <td valign="top" v-else :class="getDecisionClass(props.item.decision)" class="decisionCell">
                  {{ props.item.decision.value }}
                </td>
                <td class="reasonCell" v-if="props.item.reason === null">{{ $t('No_Reason') }}</td>
                <td class="reasonCell" v-else>
                  <pre>{{ props.item.reason }}</pre>
                </td>
                <td class="dateCell" v-if="props.item.decisionDate != null">{{ $filters.DateTimeFilter(props.item.decisionDate) }}</td>
              </tr>

              <template v-if="props.item.history">
                <tr v-for="(historyItem, index) in reversedHistory(props.item.history)" :key="index" class="ownerDecisionHistory">
                  <td class="userCell">{{ historyItem.insertedBy.displayName }}</td>
                  <td class="decisionCell">{{ historyItem.decision.value }}</td>
                  <td class="commentCell" v-if="historyItem.decision.key == null || historyItem.reason == null">&nbsp;</td>
                  <td class="commentCell" v-if="historyItem.decision.key != null && historyItem.reason != null">
                    <pre style="white-space: pre-wrap;">{{ historyItem.reason }}</pre>
                  </td>
                  <td class="dateCell" v-if="historyItem.decision.key == null">&nbsp;</td>
                  <td class="dateCell" v-if="historyItem.decision.key != null">{{ $filters.DateTimeFilter(historyItem.decisionDate) }}</td>
                </tr>
              </template>
            </template>
          </v-data-table>
        </template>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ownerDecisionHeaders: [
        {
          title: this.$t('Owner'),
          key: 'ownerDecision.insertedBy'
        },
        {
          title: this.$t('Decision'),
          key: 'decision'
        },
        {
          title: this.$t('Reason'),
          key: 'reason'
        },
        {
          title: this.$t('Date'),
          key: 'decisionDate'
        }
      ]
    }
  },
  props: {
    ownerDecision: {
      type: Object,
      default: () => ({})
    },
    showHistory: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    od: function() {
      if (this.ownerDecision) {
        let x = []
        let result = Object.fromEntries(Object.entries(this.ownerDecision).map(([key, val]) => [key, val]))

        x.push(result)
        return x
      }
      return null
    },
    ownerDecisionHistory: function() {
      if (this.ownerDecision.history) {
        let x = []
        let result = Object.fromEntries(Object.entries(this.ownerDecision.history).map(([key, val]) => [key, val]))

        x.push(result)
        return x
      }
      return null
    }
  },
  methods: {
    getDecisionClass(decision) {
      return decision.key === 'approved' ? 'approved' : 'rejected'
    },
    reversedHistory: function(arr) {
      if (!arr) return

      return arr
        .map(h => h)
        .filter(a => {
          return a.decision.key !== null
        })
        .reverse()
    }
  }
}
</script>

<style scoped>
.approved {
  color: green;
}
.rejected {
  color: #d50000;
}
pre {
  font-family: 'Roboto mono', monospace;
}
.userCell {
  vertical-align: top;
  min-width: 300px;
  max-width: 300px;
}
.decisionCell {
  vertical-align: top;
  min-width: 150px;
  max-width: 150px;
}
.dateCell {
  vertical-align: top;
  min-width: 200px;
  max-width: 200px;
}
.reasonCell {
  vertical-align: top;
  width: 100%;
}
.ownerDecisionHistory {
  background-color: rgb(236, 236, 241);
}

.theme--dark .ownerDecisionHistory {
  background-color: rgb(54, 54, 56);
}
</style>
